module.exports = __webpack_public_path__ + "static/media/ico-print-test.2f1578bd.svg";